export default "__VITE_ASSET__CD6vYXYE__"